// One place to show short messages ("Added.", "Sent to 2 devices", errors) from anywhere in the app.
import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';
import { Alert, Snackbar, type AlertColor } from '@mui/material';

type Notice = { text: string; severity: AlertColor; key: number };
type Show = (text: string, severity?: AlertColor) => void;
const NoticeContext = createContext<Show>(() => {});

export function NoticeProvider({ children }: { children: ReactNode }) {
  const [notice, setNotice] = useState<Notice | null>(null);
  const show = useCallback<Show>((text, severity = 'info') => setNotice({ text, severity, key: Date.now() }), []);
  return (
    <NoticeContext.Provider value={show}>
      {children}
      <Snackbar
        key={notice?.key}
        open={Boolean(notice)}
        autoHideDuration={6000}
        onClose={() => setNotice(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={notice?.severity ?? 'info'} variant="filled" onClose={() => setNotice(null)}>
          {notice?.text}
        </Alert>
      </Snackbar>
    </NoticeContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const useNotice = () => useContext(NoticeContext);
